__turbopack_context__.v({
  "axislabel": "dEW71a_axislabel",
  "container": "dEW71a_container",
  "description": "dEW71a_description",
  "descriptionText": "dEW71a_descriptionText",
  "desktopButton": "dEW71a_desktopButton",
  "graph": "dEW71a_graph",
  "inner": "dEW71a_inner",
  "mobileButton": "dEW71a_mobileButton",
});
